import { Box } from '@chakra-ui/react'
import { insuranceProviderFields, ScreenContext, useCollection } from '@hb/react'
import { EditCollection, EditedProps, FormElement, PageContainer } from '@hb/react-web'
import { InsuranceProvider, insurersCollection } from '@hb/shared'
import React, { useContext } from 'react'

const InsuranceProviderBody: React.FC<EditedProps<InsuranceProvider>> = ({ expanded }) =>
  expanded ? (
    <Box w="100%" p={4}>
      <FormElement active={true} name="" field={insuranceProviderFields} />
    </Box>
  ) : null

const InsuranceProviderSection: React.FC = () => {
  const { contentWidth } = useContext(ScreenContext)
  const providersData = useCollection(insurersCollection)
  return providersData ? (
    <PageContainer fullHeight noFooter overflow="hidden">
      <EditCollection
        collection={insurersCollection}
        data={providersData}
        width={contentWidth}
        ItemComponent={InsuranceProviderBody}
        name="Insurers"
        itemPlaceholder="Insurer Name"
        itemName="Insurer"
      />
    </PageContainer>
  ) : null
}

export default InsuranceProviderSection
